import { render, staticRenderFns } from "./v-contact.vue?vue&type=template&id=d977f05e&"
import script from "./v-contact.vue?vue&type=script&lang=js&"
export * from "./v-contact.vue?vue&type=script&lang=js&"
import style0 from "./v-contact.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports